<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. The First Shot</a></p>
<p class="toc"><a href="#/chapter02">2. Kieft’s War</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Monmouth Courthouse</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Paulus Hook and Camp Jersey City: New Jersey’s War of 1812 Command Center</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. The Jersey Boys Take California</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. A “Peculiar” History: The Tenth New Jersey Infantry in the Civil War</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Jersey Boys to the Rescue</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. The New Jersey National Guard Grows Up: 1895–1921</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Black Tom and Kingsland: The Jersey Mosquitoes Were Not to Blame</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. “Heaven, Hell or Hoboken”</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. On the Road to War Once More</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. “The Finest Thing I Have Seen”: The Immortal Chaplain from Newark</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. The Greatest New Jersey War Myth</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. A Jersey Girl Goes to War</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. The War at Home</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">16. Senator McCarthy Pays a Visit to New Jersey</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">17. New Jersey’s Nikes</span></p>
<p class="toc1"><span href="#/appendix" title="Link target outside of Sample">Appendix. New Jersey Historic Military Sites and Museums Worth Visiting</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?248667e4